// extracted by mini-css-extract-plugin
module.exports = {"root":"FaqItem_root__2ky7Q","header":"FaqItem_header__39hup","content":"FaqItem_content__2gB7C"};